<div *ngIf="icon" class="empty-state-icon">
  <i2g-icon class="icon" [icon]="icon"></i2g-icon>
</div>

<div *ngIf="title" class="empty-state-title" data-e2e-id="empty-state-title">
  {{ title }}
</div>

<div
  *ngIf="description"
  class="empty-state-description"
  data-e2e-id="empty-state-description"
>
  {{ description }}
</div>
